import api from './api';

export const bannerApi = {
  // { PC: [...], MOBILE: [...] } 형태로 반환
  getBanners: async () => {
    const response = await api.getPublic('/banners?locale=ko');
    return response.data.data;
  },

  trackClick: async (bannerId) => {
    await api.postPublic(`/banners/${bannerId}/click`);
  },
};
